/**
 * Frame Loader — Turbo Frame error handling
 * ==========================================
 *
 * Provides graceful error UI when a Turbo Frame endpoint fails
 * (returns a response without the expected <turbo-frame> element).
 */

(function () {
    'use strict';

    if (document.documentElement.dataset.frameLoaderInit) return;
    document.documentElement.dataset.frameLoaderInit = 'true';

    document.addEventListener('turbo:frame-missing', function (event) {
        var frame = event.target;
        event.preventDefault();
        frame.innerHTML =
            '<div class="alert alert-warning m-3" role="alert">' +
            '<i class="bi bi-exclamation-triangle me-2"></i>' +
            'Unable to load content. ' +
            '<a href="javascript:location.reload()" class="alert-link">Retry</a>' +
            '</div>';
    });
})();
